import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { toArray } from '../common/util';

import {fetchResources,} from '../redux/actions';
import {resourceSelector, authSelector} from "../redux/selectors";
import {hasPermission} from '../common/permissions';
import ResourceItem from './ResourceItem';
import ResourceForm from './ResourceForm';
import HoverEdit from '../common/hoveredit';


class ResourceList extends Component {

    componentDidMount() {
        this.props.getResources(this.props.chapter.id, this.props.dkp.slug);
    }

    render() {
        if (hasPermission('dkp.change_resource',this.props.auth.permissions) || hasPermission('dkp.add_resource', this.props.auth.permissions)) {
            return (
                <div>
                    {toArray(this.props.resources.data).filter((resource) => resource.section === this.props.dkp.id)
                        .sort((a, b) => a.category.localeCompare(b.category))
                        .filter((value, index, self) => self.map(x => x.category).indexOf(value.category) === index)
                        .map((res, i) => (
                        <div>
                            { res.category ? (
                            <div key={`${i}-resource-cat`} className="panel-adt">
                                <h2>{res.category}</h2>
                            </div>
                            ) : (
                            <div key={`${i}-resource-cat`} className="panel-adt">
                                <h2>Uncategorized</h2>
                            </div>
                            )
                            }

                            {toArray(this.props.resources.data)
                                .filter((resource) => resource.section === this.props.dkp.id)
                                .filter((resource) => resource.category === res.category)
                                .sort((a, b) => a.title.localeCompare(b.title))
                                .map((resource, i) => (
                                <div key={`${i}-resource`} className="panel-adt">
                                    <HoverEdit add={true} handleDelete={this.props.delResource} target={{resource: resource, chapter: this.props.chapter, section: this.props.dkp}}>
                                        <ResourceItem onSubmit={this.props.editResource} contributionSubmit={this.props.newResourceContribution} resource={resource} chapter={this.props.chapter} edit={this.props.edit} />
                                    </HoverEdit>
                                </div>
                            ))}
                        </div>
                    ))}
                    <div className="panel-adt">
                        <ResourceForm form='resourceForm' onSubmit={this.props.newResource} initialValues={{chapter: this.props.chapter, section: this.props.dkp, dkp: 0}} new={true} editToggle={null} />
                    </div>
                </div>
            )
        } else {
            return (
                <Redirect to="/" />
            )
        }
    }
}

const mapStateToProps = (state) => ({
    auth: authSelector(state),
    resources: resourceSelector(state),
});

const mapDispatchToProps = (dispatch) => ({
    getResources: (chapter, section) => dispatch(fetchResources(chapter, section)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ResourceList);


// WEBPACK FOOTER //
// ./src/Officer/ResourceList.js